import React, { Component } from 'react';
import {Coachmark, DirectionalHint, TeachingBubbleContent} from "office-ui-fabric-react";
//icons
import emailIcon from "../images/icons/email.svg";
import linkedinIcon from "../images/icons/linkedin.svg";
import githubIcon from "../images/icons/github.svg";
import resumeIcon from "../images/icons/resume.svg"


//resume
import resume from "../files/jason-liu-resume-online.pdf";


import './FlickerBanner.css';

//props name
export default class FlickerBanner extends Component {
    constructor(props)
    {
        super(props);
        this._popupRef = React.createRef();
        this.state = {
            isPopUpVisible: true
        }

    }

    componentDidMount()
    {
        setTimeout(() => {
            this.forceUpdate();
        }, 1000);
    }

    render() {
        
        var that = this;

        /*
        var button = (<DefaultButton 
                        text = "click"
                        onClick = {() => {
                            that.setState({
                                isPopUpVisible: !that.state.isPopUpVisible
                            })
                        }}/>)
        */
        var r = (<a href = {resume} target = "_blank" rel = "noopener noreferrer " ><img alt = "Resume" className = "flicker-Banner-icons" src = {resumeIcon}
                    ref = {this._popupRef}></img></a>);
        return (
            <div className = "flickerbanner-container">
                <div className = "flicker-Banner">
                    <div className = "flicker-Border">
                        <h1 className = "name flicker-text" style = {{fontSize: "60pt", height: "50px" }}> Jason <span className = "flicker"> C</span>. <span className = "flicker-1">Liu</span></h1>
                        <div style = {{height: "30px"}}>
                            <div>
                                <h2 className = "occupation flicker-Banner-element" style = {{fontSize: "20pt"}}>{this.props.occupation}</h2>
                                <div className = "flicker-Banner-element">
                                    <a href = "mailto:jason.l558525@gmail.com"><img alt = "Email" className = "flicker-Banner-icons" src = {emailIcon}></img></a>
                                    <a href = "https://www.linkedin.com/in/jasonliu5585/"><img alt = "Linkedin" className = "flicker-Banner-icons" src = {linkedinIcon}></img></a>
                                    <a href = "https://github.com/TropicalSunshine"><img alt = "Github" className = "flicker-Banner-icons" src = {githubIcon}></img></a>
                                    {r}
                                    {that.state.isPopUpVisible && (<Coachmark 
                                        target = {this._popupRef.current}
                                        positioningContainerProps ={{
                                            directionalHint: DirectionalHint.rightCenter,
                                            doNotLayer: false
                                        }}
                                        ariaAlertText = "Check Out My Resume"
                                        >
                                        <TeachingBubbleContent
                                        hasCloseIcon = {true}
                                        onDismiss = {function(){
                                            that.setState({
                                                isPopUpVisible: false
                                            })
                                        }}>
                                            Check out my resume!
                                        </TeachingBubbleContent>
                                    </Coachmark>)}
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
